var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tool-component"},[_c('div',{staticClass:"tools"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showTop),expression:"showTop"}],staticClass:"tool-item top",on:{"click":function($event){return _vm.scrollToTop()}}},[_c('svg-icon',{attrs:{"name":"top"}}),_c('svg-icon',{attrs:{"name":"top2"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }